import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 确保FontAwesome正确导入
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/tailwind.css'

// console.log('FontAwesome已导入')

const app = createApp(App)
app.use(store)
   .use(router)
   .use(ElementPlus)
   .mount('#app') 